'use strict';

const processInclude = require('app_storefront_base/util');
const CONST = require('plugin_frontend_core/constants');
const swiper = require('plugin_frontend_components/components/sliders');

const selectors = {
    tileWrapper: '.js-product',
    tileContainer: '.js-product-tile',
    tileImageContainer: '.js-product-tile-image-container',
    tileImage: '.js-product-tile-image',
    tileSrcSet: '.js-product-tile-srcset',
    tileLink: '.js-product .js-product-tile-link',
    quickViewContainer: '.js-product-quickview',
    quickViewPrice: '.js-product-quickview-price',
    colorVariant: '.js-quickview-color-variant',
    sizeVariant: '.js-quickview-size-variant'
};

const productTileObserverOptions = {
    rootMargin: '-20% 0px -20% 0px',
    threshold: 0.5
};

/**
 * Create observer for tracking product tile impression
 */
const productTileObserver = new IntersectionObserver((entries, observer) => {
    const productImpressions = [];

    entries.forEach(function (entry) {
        if (entry.isIntersecting && productImpressions.indexOf(entry.target) === -1) {
            productImpressions.push(entry.target);
            observer.unobserve(entry.target);
            entry.target.dataset.isObserved = false; // eslint-disable-line no-param-reassign
        }
    });

    if (productImpressions.length) {
        $(document).trigger(CONST.events.productTileImpression, [productImpressions]);
    }
}, productTileObserverOptions);

/**
 * Find products in viewport function
 */
function inViewPort() {
    $(selectors.tileContainer).each(function (i, productTile) {
        if (productTile.dataset.isObserved !== 'true') {
            productTileObserver.observe(productTile);
            productTile.dataset.isObserved = true; // eslint-disable-line no-param-reassign
        }
    });
}

/**
 * Find products in viewport function when Carousel Loads
 */
function onEinsteinCarouselLoad() {
    $('body').on(CONST.events.einsteinLoadedGtm, function () {
        $(document).ready(function () {
            inViewPort();
            swiper.initProductTileSwiper();
        });
        $('body').trigger(CONST.events.calculateWaardechequePrices);
    });
}

const attributes = {
    dataImage: 'data-image',
    dataRetinaImage: 'data-image', // TODO LROS: change this
    dataHoverImage: 'data-hover-image',
    dataHoverRetinaImage: 'data-hover-image', // TODO LROS: change this
    dataQuickViewUrl: 'data-quickview'
};

const $document = $(document);

/**
 * TODO
 */
function productQuickView() {
    /**
     * TODO
     * @param {MouseEvent} event TODO
     */
    function handleQuickView(event) {
        const $target = $(event.currentTarget);
        const $quickview = $target.find(selectors.quickViewContainer);

        $quickview.toggleClass(CONST.classes.show, event.type === CONST.events.mouseenter);
    }

    $document.on(`${CONST.events.mouseenter} ${CONST.events.mouseleave}`, `${CONST.selectors.notTouch} ${selectors.tileWrapper}`, handleQuickView);
}

function productVariationChange() {
    function getVariationTileByColor(event) {
        event.preventDefault();
        var $elm = $(event.target);
        var $quickViewContainer = $elm.parents(selectors.quickViewContainer);
        var quickViewUrl = $elm.attr(attributes.dataQuickViewUrl) || $elm.parents().attr(attributes.dataQuickViewUrl);
        if (quickViewUrl) {
            $.ajax({
                url: quickViewUrl,
                method: 'GET',
                success: function (data) {
                    var $quickviewHtml = $(data).find(selectors.quickViewContainer);
                    $quickviewHtml.addClass('show');
                    $quickViewContainer.replaceWith($quickviewHtml);
                    // Reinitialize Swiper after HTML replacement
                    swiper.initProductTileSwiper();
                    $('body').trigger(CONST.events.calculateWaardechequePrices);
                }
            });
        }
    }

    function getVariationTileBySize(event) {
        event.preventDefault();
        var $elm = $(event.target);
        var $quickViewPriceContainer = $elm.parents(selectors.quickViewContainer).find(selectors.quickViewPrice);
        var quickViewUrl = $elm.attr(attributes.dataQuickViewUrl) || $elm.parents().attr(attributes.dataQuickViewUrl);
        if (quickViewUrl) {
            $.ajax({
                url: quickViewUrl,
                method: 'GET',
                success: function (data) {
                    var $quickViewPriceHtml = $(data).find(selectors.quickViewPrice);
                    $quickViewPriceContainer.replaceWith($quickViewPriceHtml);
                    $('body').trigger(CONST.events.calculateWaardechequePrices);
                }
            });
        }
    }

    $document.on(`${CONST.events.click}`, `${selectors.colorVariant}`, getVariationTileByColor);
    $document.on(`${CONST.events.click}`, `${selectors.sizeVariant}`, getVariationTileBySize);
}

/**
 * TODO
 */
function productHoverImageChange() {
    /**
     * TODO
     * @param {*} tileImage TODO
     * @param {*} tileHoverImage TODO
     * @returns {string} TODO LROS
     */
    function constructSrcSetPath(tileImage, tileHoverImage) {
        return `${tileImage} 1x, ${tileHoverImage}`;
    }

    /**
     * TODO
     * @param {*} event TODO
     */
    function handleHoverImages(event) {
        const $target = $(event.currentTarget);
        const $tile = $target.find(selectors.tileImageContainer);
        let $tileImage = $tile.find(selectors.tileImage);
        let $tileSrcSet = $tile.find(selectors.tileSrcSet);

        let productImages = {
            defaultImage: $tile.attr(attributes.dataImage),
            defaultRetinaImage: $tile.attr(attributes.dataRetinaImage),
            hoverImage: $tile.attr(attributes.dataHoverImage),
            hoverRetinaImage: $tile.attr(attributes.dataHoverRetinaImage)
        };

        if (event.type === CONST.events.mouseenter) {
            $tileImage.attr(CONST.attributes.src, productImages.hoverImage);

            if ($tileSrcSet[0]) {
                $tileSrcSet.attr(
                    CONST.attributes.srcset,
                    constructSrcSetPath(productImages.hoverImage, productImages.hoverRetinaImage)
                );
            }
        }

        if (event.type === CONST.events.mouseleave) {
            $tileImage.attr(CONST.attributes.src, productImages.defaultImage);

            if ($tileSrcSet[0]) {
                $tileSrcSet.attr(
                    CONST.attributes.srcset,
                    constructSrcSetPath(productImages.defaultImage, productImages.defaultRetinaImage)
                );
            }
        }
    }

    // JVP @TODO: Converted current image replacement setup in `handleQuickView` in `handleHoverImages`?
    // $document.on(CONST.events.mouseenter, selectors.tileContainer, handleHoverImages);
    // $document.on(CONST.events.mouseleave, selectors.tileContainer, handleHoverImages);
}

/**
 * Event listener for size select option change to update tile wrapper pid to add correct product to the cart
 */
function onCompactTileSizeChange() {
    $(CONST.selectors.form.select).on(CONST.events.change, function () {
        var selectedOption = $(this).find('option:selected');
        var selectedPid = selectedOption.data('pid');
        var productElement = $(this).closest(selectors.tileWrapper);

        if (productElement.length) {
            productElement.attr('data-pid', selectedPid);
        }
    });
}

module.exports = {
    init: function () {
        processInclude(require('plugin_catalog/product/quickview'));
        processInclude(require('plugin_wishlists/product/tile'));

        /**
         * On product tile click
         */
        $(CONST.selectors.body).on(CONST.events.click, selectors.tileLink, function (event) {
            // skip if the click was on swipper buttons
            if ($(event.target).is('.swiper-button-prev, .swiper-button-next')) {
                return;
            }

            // Trigger custom event for product tile click
            const $productTileWrapper = $(this).closest(selectors.tileWrapper);
            $(document).trigger(CONST.events.productTileClick, {
                $productTileWrapper: $productTileWrapper
            });
        });

        $(CONST.selectors.body).on(CONST.events.productAfterAddToCart, function (e, response) {
            const selectedProduct = $('.js-product-quickview[data-pid="' + response.productID + '"]');
            if (selectedProduct.find('.range__details').attr('data-js-waardecheck') !== 'null') {
                $('.range__details').removeClass('range__details--waardecheck');
                $('.price').find('.waardecheck').addClass('hidden');
                $('.price').find('.waardecheck__msg').addClass('hidden');
                $('.waardecheck-info').remove();
            }
        });

        onCompactTileSizeChange();
    },
    productVariationChange: productVariationChange,
    productQuickView: productQuickView,
    productHoverImageChange: productHoverImageChange,
    inViewPort: inViewPort,
    onEinsteinCarouselLoad: onEinsteinCarouselLoad
};
